import * as wjcSheet from '@grapecity/wijmo.grid.sheet';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { SuncorFluidAnalysis } from '../../../_models/_fluid/suncor-fluid-analysis';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { AssayCellConfig, AssaySheetRows } from '../cell-config/assay-cell-config';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { AssayFlexsheetMapper } from '../mappers/assay-flexsheet-mapper';

export class AssayFlexsheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(assay: SuncorFluidAnalysis, spreadsheet: wjcSheet.FlexSheet, flexsheetEvent, rawValue) {
    const { row } = flexsheetEvent;

    if (enumValuesToArray(AssaySheetRows).indexOf(row) === -1) {
      flexsheetEvent.cancel = true;
      return;
    }

    const cellConfig = AssayCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new AssayFlexsheetMapper(simulationVariableMapper);

    mapper.map(assay, row, convertedValue);
  }
}
